<template lang="pug">
  v-card
    v-card-title(class="justify-center body-1") {{ $t('vipDevice.TITLE') }}
    v-card-text
      ValidationObserver(ref="form" v-slot="{ validate, dirty, invalid }")
        form(@submit.prevent="onSubmit")
          v-layout(column)

            v-row(align="center" justify="center")
              v-col(cols="12" sm="12" md="6" lg="6" xl="6")
                ValidationProvider(name="description" rules="required")
                  div(slot-scope="{ errors }")
                    v-text-field(outlined background-color="white" hide-details id="description" name="description" :label="$t('vipDevice.DESCRIPTION')" v-model="description" :data-vv-as="$t('vipDevice.DESCRIPTION')" autocomplete="off")
                    p(class="red--text caption") {{ errors[0] }}

            v-row(align="center" justify="center")
              v-col(cols="12" sm="12" md="6" lg="6" xl="6")
                ValidationProvider(name="macaddress" rules="required|macaddress")
                  div(slot-scope="{ errors }")
                    v-text-field(outlined background-color="white" hide-details id="macaddress" name="macaddress" :label="$t('vipDevice.MACADDRESS')" v-model="macaddress" :data-vv-as="$t('vipDevice.MACADDRESS')" autocomplete="off" v-mask="'NN:NN:NN:NN:NN:NN'")
                    p(class="red--text caption") {{ errors[0] }}

                v-btn(color="secondary" :disabled="invalid" @click="makeVip" block) {{ $t('vipDevice.VIPBTN') }}
</template>
<script>

import { ValidationProvider, ValidationObserver, localize } from "vee-validate"
import { mapActions } from 'vuex'

export default{
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data(){
    return{
      macaddress: '',
      description: ''
    }
  },
  methods:{
    ...mapActions(['makeDeviceVip']),
    async makeVip(){
      await this.makeDeviceVip({
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        mac: this.macaddress,
        deviceName: this.description,
        vip: true
      })
    }
  }
}

</script>
